import React, { useId, useState } from 'react';

export default function ResultCollapsibleSection({ title, className = '', children }) {
    const [isOpen, setIsOpen] = useState(false);
    const generatedId = useId().replace(/:/g, '');
    const buttonId = `result-toggle-${generatedId}`;
    const panelId = `result-panel-${generatedId}`;

    return <section className={`result-collapsible ${className}`.trim()}>
        <button
            id={buttonId}
            type="button"
            className="result-collapse-toggle"
            aria-expanded={isOpen}
            aria-controls={panelId}
            onClick={() => setIsOpen(open => !open)}
        >
            <span className="result-collapse-marker" aria-hidden="true" />
            <span>{title}</span>
        </button>
        {isOpen && <div id={panelId} className="result-collapse-panel" role="region" aria-labelledby={buttonId}>
            {children}
        </div>}
    </section>;
}
